import Jt808ServCombineOrderConfirmReceptModal from './jt808-serv-combine-order-confirm-recept-modal.vue'
export default Jt808ServCombineOrderConfirmReceptModal
